import React from "react";
import {Box, Stack, Button, Card, CardContent, CardHeader, Typography} from "@mui/material";
import AlertMessage from "../../../Common/Alert/AlertMessage";
import SpeakerNotesIcon from '@mui/icons-material/SpeakerNotes';
import ActivityReviewComment from "./ActivityReviewComment";

function ActivityReviewContent ({activity, onClick}) {

    const isRequired = activity?.review?.isRequired;
    const status = activity?.review?.status ?? 'open';

    let alert = {
        severity: 'info',
        message: 'This section is optional'
    };

    if (isRequired) {
        alert.severity = 'warning'
        alert.message = 'You are required to complete this section'
    }

    switch (status) {

        case 'completed':
            alert.severity = 'success'
            alert.message = 'Reflection completed'
            break

        case 'n/a':
            alert.message = 'Reflection marked as not applicable';
            break

        default:
            break

    }

    return (

        <Card className="card">
            <CardHeader
                disableTypography={true}
                title={<Typography component="h2" className="card-header-title">Reflection</Typography>}
                subheader={
                    <Typography component="span" className="card-header-subtitle">
                        Add your notes here
                    </Typography>
                }
                action={
                    <Stack
                        direction="row"
                        justifyContent="flex-start"
                        alignItems="center"
                        spacing={2}
                        sx={{padding: '8px'}}
                    >
                        {activity.canUpdate && (
                            <Button
                                variant="contained"
                                color="neutral"
                                disableElevation={true}
                                aria-label="Write a reflection"
                                onClick={onClick}
                                startIcon={<SpeakerNotesIcon />}
                            >Reflection
                            </Button>
                        )}
                    </Stack>
                }
            />

            <CardContent>
                <Box className="card-content">
                    <AlertMessage severity={alert.severity} message={alert.message} />
                </Box>
            </CardContent>

            <CardContent >
                <Box className="card-content">
            { activity?.review?.comments?.length && (
                activity.review.comments.map((comment, index) => (
                    <ActivityReviewComment comment={comment} key={'comments_' + index}/>
                ))
            )}
                </Box>
            </CardContent>

        </Card>
    );
}

export default ActivityReviewContent;